<template>
  <div>
    <div class="content">
      <div class="title">基本信息</div>
      <div class="base clearfix">
        <div class="item">
          <div class="label">产品名称</div>
          <div class="value">{{ detailInfo.productCode }}/{{ detailInfo.productName }}</div>
        </div>
        <div class="item">
          <div class="label">支付时间</div>
          <div class="value">{{ detailInfo.payTime | cutString(16) }}</div>
        </div>
        <div class="item">
          <div class="label">订单号</div>
          <div class="value">{{ detailInfo.orderNo }}</div>
        </div>
        <div class="item">
          <div class="label">保单号</div>
          <div class="value">{{ detailInfo.policyNo }}</div>
        </div>
        <div class="item">
          <div class="label">保险期间</div>
          <div class="value">{{ detailInfo.startTime | cutString(10) }} 至 {{ detailInfo.endTime | cutString(10) }}</div>
        </div>
        <div v-if="detailInfo.policyUrl" class="item">
          <div class="label">电子保单</div>
          <div class="value">
            <a :href="detailInfo.policyUrl">
              <el-button type="primary" size="small">下载电子保单</el-button>
            </a>
          </div>
        </div>
        <div class="item">
          <div class="label">保险公司</div>
          <div class="value">{{ detailInfo.companyName }}</div>
        </div>
        <div class="item">
          <div class="label">业务类别</div>
          <div class="value">{{ detailInfo.sellType }}</div>
        </div>
        <div class="item" v-if="detailInfo.coverage">
          <div class="label">保额</div>
          <div class="value">{{ detailInfo.coverage }}元</div>
        </div>
        <div class="item">
          <div class="label">出单保费</div>
          <div class="value">{{ detailInfo.fee }}元</div>
        </div>
        <div class="item" v-if="userinfo.level == 1">
          <div class="label">出单服务费</div>
          <div class="value">{{ detailInfo.commission }}元</div>
        </div>
        <div class="item">
          <div class="label">出单机构/员工</div>
          <div class="value">{{ detailInfo.mechanName }}</div>
        </div>
        <div class="item">
          <div class="label">付款方式</div>
          <div class="value">{{ payTypeMap[detailInfo.payType] }}</div>
        </div>
        <div class="item">
          <div class="label">保单状态</div>
          <div class="value">{{ statusMap[detailInfo.status] }}</div>
        </div>
        <template v-if="detailInfo.status == '3'">
          <Divider />
          <div class="descLine"></div>
          <div class="item">
            <div class="label">退费金额</div>
            <div class="value">{{ detailInfo.refundFee }}元</div>
          </div>
          <div class="item">
            <div class="label">退保生效时间</div>
            <div class="value">{{ detailInfo.refundStartTime | cutString(16) }}</div>
          </div>
          <div class="item">
            <div class="label">退保类型</div>
            <div class="value">{{ refundTypeMap[detailInfo.refundType] }}</div>
          </div>
          <div class="item" v-if="userinfo.level == 1 && detailInfo.reduceCommission">
            <div class="label">预估扣减服务费</div>
            <div class="value">{{ detailInfo.reduceCommission }}元</div>
          </div>
        </template>
      </div>
      <div class="title">投保人信息</div>
      <div class="base clearfix">
        <div class="item">
          <div class="label">投保人名称</div>
          <div class="value">{{ detailInfo.holderName }}</div>
        </div>
        <div class="item">
          <div class="label">投保人证件号</div>
          <div
            class="value"
            :class="{ 'can-click': detailInfo.isDecrypt && detailInfo.holderCardNoMask }"
            @dblclick="
              detailInfo.holderCardNoMask &&
                detailInfo.isDecrypt &&
                descrypt(1, 1, detailInfo.holderCardNoMd5, detailInfo.policyNo, 'holderCardNoMask', detailInfo)
            "
          >
            {{ detailInfo.holderCardNoMask }}
          </div>
        </div>
        <div class="item">
          <div class="label">投保人地址</div>
          <div
            class="value"
            :class="{ 'can-click': detailInfo.isDecrypt && detailInfo.holderAddress }"
            @dblclick="
              detailInfo.holderAddress && detailInfo.isDecrypt && descrypt(1, 8, detailInfo.holderAddressMd5, detailInfo.policyNo, 'holderAddress', detailInfo)
            "
          >
            {{ detailInfo.holderAddress }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['id'],
  data() {
    return {
      statusMap: {
        '3': '退保',
        '4': '终止',
        '1': '保障中'
      },
      refundTypeMap: {
        '1': '生效前退保 ',
        '2': '保障期间退保',
      },
      payTypeMap: {
        '1': '梧桐树代收',
        '2': '保司在线收银台',
        '3': '保司公对公收款',
      },
      detailInfo: {},
      userinfo: {}
    };
  },
  created() {
    this.userinfo = this.$tools.getLocal("userinfo");
    this.getDetail()
  },
  filters: {
    cutString(value, length) {
      if (!value) {
        return '';
      }
      let val = value.toString().substring(0, length);
      return val;
    },
  },
  methods: {
    getDetail() {
      this.$http({
        url: '/master/group/queryPolicyDetail',
        type: 'GET',
        params: { id: this.id }
      }).then((res) => {
        this.detailInfo = res.data;
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.tools-box {
  display: flex;
  justify-content: flex-end;
}

.content {
  font-size: 14px;

  .title {
    color: #333;
    margin-top: 10px;
    margin-bottom: 10px;
    font-weight: bold;

    &::before {
      content: '';
      display: inline-block;
      width: 2px;
      height: 14px;
      background-color: #333;
      margin-right: 10px;
      position: relative;
      top: 2px;
    }
  }

  .base {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 40px;

    .c-red {
      color: #e3461f;
    }

    .item {
      width: 25%;
      display: inline-block;
      flex: 0 0 25%;
      line-height: 3;
      display: flex;
      padding-right: 25px;

      > div {
        &.label {
          margin-right: 5px;
          flex: 0 0 100px;
        }
      }
    }
  }

  .descLine {
    border-bottom: 1px solid #eee;
  }
}
</style>